import React from "react";
import { Link } from "react-router-dom";
import "./AskMariamlyPolicyPage.css";

// Policy Icons
function ShieldIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  );
}

function BrainIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-6.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z"/>
      <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-6.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z"/>
    </svg>
  );
}

function CameraIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z"/>
      <circle cx="12" cy="13" r="3"/>
    </svg>
  );
}

function LockIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
      <circle cx="12" cy="16" r="1"/>
      <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
    </svg>
  );
}

function CheckCircleIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
      <polyline points="22,4 12,14.01 9,11.01"/>
    </svg>
  );
}

function AlertTriangleIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
      <line x1="12" y1="9" x2="12" y2="13"/>
      <line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  );
}

function MessageCircleIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
    </svg>
  );
}

function HeartIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>
  );
}

function EyeIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  );
}

function DatabaseIcon({ size = 24, color = "#d19e90" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <ellipse cx="12" cy="5" rx="9" ry="3"/>
      <path d="M3 5v14c0 1.66 4.03 3 9 3s9-1.34 9-3V5"/>
      <path d="M3 12c0 1.66 4.03 3 9 3s9-1.34 9-3"/>
    </svg>
  );
}

export default function AskMariamlyPolicyPage() {
  return (
    <div className="mariamly-ask-mariamly-policy-page">
      {/* Banner Section */}
      <div className="policy-banner">
        <div className="policy-banner-content">
          <h1 className="policy-banner-title">Ask Mariamly AI Policy</h1>
          <div className="policy-breadcrumb">
            <Link to="/">Home</Link>
            <span>/</span>
            <span>Ask Mariamly AI Policy</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="policy-content">
        {/* Introduction Section */}
        <div className="policy-intro">
          <div className="intro-content">
            <h2>Ask Mariamly AI Chatbot Policy – Mariamly Luxe</h2>
            <p className="intro-lead">
              Welcome to Ask Mariamly, our AI-powered beauty assistant! This policy outlines how our chatbot interacts with you, protects your privacy, and provides personalized beauty recommendations based on our curated product collection.
            </p>
          </div>
          <div className="intro-image">
            <div className="image-placeholder">
              <BrainIcon size={48} color="#d19e90" />
            </div>
          </div>
        </div>

        {/* AI Assistant Overview Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <MessageCircleIcon size={40} />
            </div>
            <h3>1. About Ask Mariamly AI Assistant</h3>
          </div>
          <div className="section-content">
            <p className="section-intro">Ask Mariamly is an AI-powered chatbot designed to help you discover the perfect beauty products from our collection:</p>
            <div className="policy-points">
              <div className="policy-point">
                <BrainIcon size={24} />
                <div className="point-content">
                  <strong>Product Recommendations:</strong> Based on your skin type, hair concerns, beauty goals, and preferences.
                </div>
              </div>
              <div className="policy-point">
                <CheckCircleIcon size={24} />
                <div className="point-content">
                  <strong>Beauty Advice:</strong> General guidance on skincare routines, makeup application, and haircare tips.
                </div>
              </div>
              <div className="policy-point">
                <HeartIcon size={24} />
                <div className="point-content">
                  <strong>Personalized Experience:</strong> Tailored suggestions that evolve with your preferences and feedback.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Image Protection & Privacy Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <CameraIcon size={40} />
            </div>
            <h3>2. Image Protection & Privacy</h3>
          </div>
          <div className="section-content">
            <div className="policy-points">
              <div className="policy-point">
                <LockIcon size={24} />
                <div className="point-content">
                  <strong>Image Security:</strong> Any images you share with Ask Mariamly are processed securely and are not stored permanently on our servers.
                </div>
              </div>
              <div className="policy-point">
                <ShieldIcon size={24} />
                <div className="point-content">
                  <strong>Privacy Protection:</strong> Your uploaded images are used solely for beauty analysis and product recommendations, never for marketing or shared with third parties.
                </div>
              </div>
              <div className="policy-point">
                <EyeIcon size={24} />
                <div className="point-content">
                  <strong>Image Analysis:</strong> Our AI analyzes images to understand your skin tone, hair color, and beauty concerns to provide better recommendations.
                </div>
              </div>
              <div className="policy-point">
                <DatabaseIcon size={24} />
                <div className="point-content">
                  <strong>Data Retention:</strong> Image data is automatically deleted after processing, typically within 24 hours of your interaction.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* AI Limitations & Disclaimers Section */}
        <div className="policy-section disclaimer-section">
          <div className="section-header">
            <div className="section-icon">
              <AlertTriangleIcon size={40} />
            </div>
            <h3>3. AI Limitations & Important Disclaimers</h3>
          </div>
          <div className="section-content">
            <div className="policy-points">
              <div className="policy-point">
                <AlertTriangleIcon size={24} />
                <div className="point-content">
                  <strong>Not Medical Advice:</strong> Ask Mariamly provides beauty recommendations only and does not replace professional medical, dermatological, or cosmetic advice.
                </div>
              </div>
              <div className="policy-point">
                <CheckCircleIcon size={24} />
                <div className="point-content">
                  <strong>Professional Consultation:</strong> For serious skin conditions, allergies, or medical concerns, always consult with a qualified healthcare professional.
                </div>
              </div>
              <div className="policy-point">
                <BrainIcon size={24} />
                <div className="point-content">
                  <strong>AI Accuracy:</strong> While we strive for accuracy, AI recommendations are based on general patterns and may not be perfect for every individual.
                </div>
              </div>
              <div className="policy-point">
                <HeartIcon size={24} />
                <div className="point-content">
                  <strong>Personal Responsibility:</strong> You are responsible for ensuring any recommended products are suitable for your personal use and skin/hair type.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Data Collection & Usage Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <DatabaseIcon size={40} />
            </div>
            <h3>4. Data Collection & Usage</h3>
          </div>
          <div className="section-content">
            <p className="section-intro">When you interact with Ask Mariamly, we may collect:</p>
            <div className="policy-points">
              <div className="policy-point">
                <MessageCircleIcon size={24} />
                <div className="point-content">
                  <strong>Conversation Data:</strong> Your questions, preferences, and feedback to improve our recommendations.
                </div>
              </div>
              <div className="policy-point">
                <CameraIcon size={24} />
                <div className="point-content">
                  <strong>Image Data:</strong> Photos you share for beauty analysis (temporarily processed, not permanently stored).
                </div>
              </div>
              <div className="policy-point">
                <BrainIcon size={24} />
                <div className="point-content">
                  <strong>Preference Data:</strong> Your beauty goals, skin type, hair concerns, and product preferences.
                </div>
              </div>
              <div className="policy-point">
                <CheckCircleIcon size={24} />
                <div className="point-content">
                  <strong>Usage Analytics:</strong> How you interact with recommendations to improve our AI's accuracy.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Product Recommendations Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <HeartIcon size={40} />
            </div>
            <h3>5. Product Recommendations & Accuracy</h3>
          </div>
          <div className="section-content">
            <div className="policy-points">
              <div className="policy-point">
                <CheckCircleIcon size={24} />
                <div className="point-content">
                  <strong>Curated Collection:</strong> All recommendations are based exclusively on products available in our Mariamly Luxe collection.
                </div>
              </div>
              <div className="policy-point">
                <BrainIcon size={24} />
                <div className="point-content">
                  <strong>Personalized Matching:</strong> Recommendations are tailored to your specific needs, preferences, and beauty goals.
                </div>
              </div>
              <div className="policy-point">
                <AlertTriangleIcon size={24} />
                <div className="point-content">
                  <strong>No Guarantees:</strong> While we strive for accuracy, we cannot guarantee that recommended products will work perfectly for every individual.
                </div>
              </div>
              <div className="policy-point">
                <HeartIcon size={24} />
                <div className="point-content">
                  <strong>Continuous Learning:</strong> Our AI learns from your feedback to provide better recommendations over time.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* User Rights & Controls Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <ShieldIcon size={40} />
            </div>
            <h3>6. Your Rights & Controls</h3>
          </div>
          <div className="section-content">
            <p className="section-intro">You have the right to:</p>
            <div className="policy-points">
              <div className="policy-point">
                <EyeIcon size={24} />
                <div className="point-content">
                  <strong>Access Your Data:</strong> Request information about what data we have collected from your interactions.
                </div>
              </div>
              <div className="policy-point">
                <CheckCircleIcon size={24} />
                <div className="point-content">
                  <strong>Delete Your Data:</strong> Request deletion of your conversation history and preferences at any time.
                </div>
              </div>
              <div className="policy-point">
                <LockIcon size={24} />
                <div className="point-content">
                  <strong>Opt-Out:</strong> Stop using Ask Mariamly at any time without affecting your ability to shop on our website.
                </div>
              </div>
              <div className="policy-point">
                <HeartIcon size={24} />
                <div className="point-content">
                  <strong>Feedback:</strong> Provide feedback to help us improve the AI's recommendations and accuracy.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Technical & Security Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <LockIcon size={40} />
            </div>
            <h3>7. Technical & Security Measures</h3>
          </div>
          <div className="section-content">
            <div className="policy-points">
              <div className="policy-point">
                <ShieldIcon size={24} />
                <div className="point-content">
                  <strong>Secure Processing:</strong> All AI processing is done through secure, encrypted channels to protect your data.
                </div>
              </div>
              <div className="policy-point">
                <DatabaseIcon size={24} />
                <div className="point-content">
                  <strong>Data Minimization:</strong> We only collect and process the minimum data necessary to provide recommendations.
                </div>
              </div>
              <div className="policy-point">
                <LockIcon size={24} />
                <div className="point-content">
                  <strong>Access Controls:</strong> Strict access controls ensure only authorized personnel can access your data for support purposes.
                </div>
              </div>
              <div className="policy-point">
                <CheckCircleIcon size={24} />
                <div className="point-content">
                  <strong>Regular Audits:</strong> We regularly audit our AI systems and data practices to ensure compliance and security.
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Policy Updates Section */}
        <div className="policy-section">
          <div className="section-header">
            <div className="section-icon">
              <ShieldIcon size={40} />
            </div>
            <h3>8. Policy Updates</h3>
          </div>
          <div className="section-content">
            <p>
              Mariamly Luxe may update this Ask Mariamly AI Policy from time to time to reflect changes in our technology, services, or legal requirements. Any significant changes will be communicated to users through our website or email notifications.
            </p>
          </div>
        </div>

        {/* Agreement Section */}
        <div className="agreement-section">
          <div className="agreement-content">
            <div className="agreement-icon">
              <BrainIcon size={32} />
            </div>
            <div className="agreement-text">
              <h4>✨ By using Ask Mariamly AI Assistant, you agree to the terms outlined in this policy.</h4>
            </div>
          </div>
        </div>

        {/* Contact Information */}
        <div className="contact-section">
          <div className="contact-content">
            <h3>Questions About Ask Mariamly AI Policy?</h3>
            <p>
              If you have any questions about our AI chatbot policy, need assistance with your data, or want to provide feedback about Ask Mariamly, our customer service team is here to help.
            </p>
            <div className="contact-buttons">
              <Link to="/contact" className="contact-button primary">
                <HeartIcon size={20} />
                <span>Contact Us</span>
              </Link>
              <Link to="/privacy-policy" className="contact-button secondary">
                <ShieldIcon size={20} />
                <span>Privacy Policy</span>
              </Link>
              <Link to="/shop" className="contact-button secondary">
                <CheckCircleIcon size={20} />
                <span>Shop Now</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
